var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11516_60905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 14.6654C4.31865 14.6654 1.33398 11.6807 1.33398 7.9987C1.33398 4.3167 4.31865 1.33203 8.00065 1.33203C11.6827 1.33203 14.6673 4.3167 14.6673 7.9987C14.6673 11.6807 11.6827 14.6654 8.00065 14.6654ZM8.00065 13.332C9.41514 13.332 10.7717 12.7701 11.7719 11.7699C12.7721 10.7697 13.334 9.41319 13.334 7.9987C13.334 6.58421 12.7721 5.22766 11.7719 4.22746C10.7717 3.22727 9.41514 2.66536 8.00065 2.66536C6.58616 2.66536 5.22961 3.22727 4.22941 4.22746C3.22922 5.22766 2.66732 6.58421 2.66732 7.9987C2.66732 9.41319 3.22922 10.7697 4.22941 11.7699C5.22961 12.7701 6.58616 13.332 8.00065 13.332ZM8.66732 7.9987H11.334V9.33203H7.33398V4.66536H8.66732V7.9987Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11516_60905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/TIME.d6b2193bb9a2deca01cf50f750cb8060.svg";
export { ForwardRef as ReactComponent };